import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ea4fab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "impersonate-container",
  class: "impersonate-container d-flex justify-content-between align-items-center border-bottom bg-tertiary text-light px-16"
}
const _hoisted_2 = { class: "text-xs py-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-expand-right text-xs me-12" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!

  return (!!_ctx.authUser && !!_ctx.authUser.impersonatedBy)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('Has iniciado sesión como el usuario { user } ({ email }).', {
          user: _ctx.authUser.name,
          email: _ctx.authUser.email,
        })), 1),
        _createVNode(_component_v_button, {
          id: "btn-stop-impersonate",
          class: "btn-icon h-100 shadow-none text-light text-sm p-0 ms-8",
          size: "sm",
          variant: "link",
          onClick: _ctx.impersonateStop
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Regresar a panel de administrador')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]))
    : _createCommentVNode("", true)
}